module.exports = __webpack_public_path__ + "static/img/icon-09.88476e04.png";